import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { getUsers } from "common/services/users.service";

const TotalUsers = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  useEffect(() => {
    const fetchTotalUsers = async () => {
      const response: any = await getUsers({});
      setTotalUsers(response.meta?.pagination?.total || 0);
    };
    fetchTotalUsers();
  }, []);
  return (
    <div className="col">
      <div className="py-4 px-3">
        <h5 className="text-muted text-uppercase fs-13">
          {"Total Users"}
          <i className={"ri-focus-line fs-18 float-end align-middle"}></i>
        </h5>
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            <i className={"ri-group-line display-6 text-muted cfs-22"}></i>
          </div>
          <div className="flex-grow-1 ms-3">
            <h2 className="mb-0 cfs-22">
              <span className="counter-value" data-target={totalUsers}>
                <CountUp
                  start={0}
                  prefix={""}
                  suffix={""}
                  separator={""}
                  end={totalUsers}
                  decimals={0}
                  duration={4}
                />
              </span>
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalUsers;
